import Hero from "./Section/Hero";
import AboutZeuss from "./Section/AboutZeuss";
import Tokenomics from "./Section/Tokenomics";
import Stories from "./Section/Stories";
import Faq from "./Section/Faq";
import Launch from "./Section/Launch";
const Home = () => {
  return (
    <>
      <div className="topbar">
        <h4>
          <a href="https://etherscan.io/address/0xa94485F44dD21C8cb547AEe50979A29272EC5326#code" target="_blank">
            $POCKET Contract Address 0xa94485F44dD21C8cb547AEe50979A29272EC5326
          </a>
        </h4>
      </div>
      <div className="wrapper">
        <Hero />
        <AboutZeuss />
        <Tokenomics />
        <Faq />
        <Stories />
        <Launch />
      </div>
    </>
  );
};
export default Home;
